import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore, setAuthorization } from 'src/helpers/api/apiCore';

// api
import {
    creatTestParamMapping as creatTestParamMappingApi,
    updateTestParamMapping as updateTestParamMappingApi,
    getAllTestParamMapping as getAllTestParamMappingApi,
    getTestParamMapping as getTestParamMappingApi,
    getTestParamsListing as getTestParamsListingApi,
} from './api';

// actions
import { testParamMappingApiResponseSuccess, testParamMappingApiResponseError } from './actions';

// constants
import { TestParamMappingActionTypes } from './constants';

type TestParamMappingData = {
    payload: any;
    type: string;
};

const api = new APICore();

/**
 * Add Test Mapping
 * @param {*}
 */
function* addTestParamMapping({ payload, type }: TestParamMappingData): SagaIterator {
    try {
        const response = yield call(creatTestParamMappingApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                testParamMappingApiResponseSuccess(
                    TestParamMappingActionTypes.ADD_TEST_PARAM_MAPPING,
                    data,
                    'Test Mapping has been created.',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while creating Test Mapping!`;
            if (message) msg = message;
            yield put(
                testParamMappingApiResponseSuccess(
                    TestParamMappingActionTypes.ADD_TEST_PARAM_MAPPING,
                    data,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            testParamMappingApiResponseError(
                TestParamMappingActionTypes.ADD_TEST_PARAM_MAPPING,
                [],
                error,
                404,
                true,
                false
            )
        );
    }
}

/**
 * Edit Test Mapping
 * @param {*}
 */
function* editTestParamMapping({ payload, type }: TestParamMappingData): SagaIterator {
    try {
        const response = yield call(updateTestParamMappingApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                testParamMappingApiResponseSuccess(
                    TestParamMappingActionTypes.EDIT_TEST_PARAM_MAPPING,
                    data,
                    'Test Mapping Get Updated Successfully',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while edit Test Mapping!`;
            if (message) msg = message;
            yield put(
                testParamMappingApiResponseSuccess(
                    TestParamMappingActionTypes.EDIT_TEST_PARAM_MAPPING,
                    data,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            testParamMappingApiResponseError(
                TestParamMappingActionTypes.EDIT_TEST_PARAM_MAPPING,
                [],
                error,
                404,
                true,
                false
            )
        );
    }
}

/**
 * Get Test Mapping
 * @param {*}
 */
function* getTestParamMapping({ payload, type }: TestParamMappingData): SagaIterator {
    try {
        const response = yield call(getTestParamMappingApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                testParamMappingApiResponseSuccess(
                    TestParamMappingActionTypes.GET_TEST_PARAM_MAPPING,
                    data,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Test Mapping!`;
            if (message) msg = message;
            yield put(
                testParamMappingApiResponseSuccess(
                    TestParamMappingActionTypes.GET_TEST_PARAM_MAPPING,
                    data,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            testParamMappingApiResponseError(
                TestParamMappingActionTypes.GET_TEST_PARAM_MAPPING,
                [],
                error,
                404,
                true,
                false
            )
        );
    }
}

/**
 * Get Test Param Mappings
 * @param {*}
 */
function* getTestParamMappings({ payload, type }: TestParamMappingData): SagaIterator {
    try {
        const response = yield call(getAllTestParamMappingApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(
                testParamMappingApiResponseSuccess(
                    TestParamMappingActionTypes.GET_TEST_PARAM_MAPPINGS,
                    responseData,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Test Param Mapping Listing!`;
            if (message) msg = message;
            yield put(
                testParamMappingApiResponseSuccess(
                    TestParamMappingActionTypes.GET_TEST_PARAM_MAPPINGS,
                    responseData,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            testParamMappingApiResponseError(
                TestParamMappingActionTypes.GET_TEST_PARAM_MAPPINGS,
                [],
                error,
                404,
                true,
                false
            )
        );
    }
}

/**
 * Get Test Param Mappings
 * @param {*}
 */
function* getTestParamsListing({ payload, type }: TestParamMappingData): SagaIterator {
    try {
        const response = yield call(getTestParamsListingApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(
                testParamMappingApiResponseSuccess(
                    TestParamMappingActionTypes.GET_TEST_PARAMS,
                    responseData,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Test Param Listing!`;
            if (message) msg = message;
            yield put(
                testParamMappingApiResponseSuccess(
                    TestParamMappingActionTypes.GET_TEST_PARAMS,
                    responseData,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            testParamMappingApiResponseError(TestParamMappingActionTypes.GET_TEST_PARAMS, [], error, 404, true, false)
        );
    }
}

export function* watchAddTestParamMapping() {
    yield takeEvery(TestParamMappingActionTypes.ADD_TEST_PARAM_MAPPING, addTestParamMapping);
}

export function* watchEditTestParamMapping() {
    yield takeEvery(TestParamMappingActionTypes.EDIT_TEST_PARAM_MAPPING, editTestParamMapping);
}

export function* watchGetTestParamMapping(): any {
    yield takeEvery(TestParamMappingActionTypes.GET_TEST_PARAM_MAPPING, getTestParamMapping);
}

export function* watchGetTestParamMappings(): any {
    yield takeEvery(TestParamMappingActionTypes.GET_TEST_PARAM_MAPPINGS, getTestParamMappings);
}

export function* watchGetTestParamsListing(): any {
    yield takeEvery(TestParamMappingActionTypes.GET_TEST_PARAMS, getTestParamsListing);
}

function* testParamMappingSaga() {
    yield all([
        fork(watchAddTestParamMapping),
        fork(watchEditTestParamMapping),
        fork(watchGetTestParamMapping),
        fork(watchGetTestParamMappings),
        fork(watchGetTestParamsListing),
    ]);
}

export default testParamMappingSaga;
